import { observer } from 'mobx-react-lite';
import React from 'react';
import { kenoBetStore } from '../../../store/kenoBetStore';
import { userInfoStore } from '../../../store/userInfoStore';
import { DEMO_GAME_CURRENCY, WIN_ODD_FOR_POPUP } from '../../../core/constants/gameConstants';
import useTranslation from '../../../hooks/useTranslation';
import { TranslationKeys } from '../../../core/constants/translationKeys';
import { applicationStore } from '../../../store/applicationStore';

export const WinPopup = observer(() => {
  const { winAmount, winOdd } = kenoBetStore;
  const { isDemo } = applicationStore;
  const { currencyCode } = userInfoStore;
  const t = useTranslation();

  if (!winAmount) {
    return null;
  }
  if (winOdd < WIN_ODD_FOR_POPUP) {
    return (
      <div className={`win-popup ${winAmount ? 'open' : ''}`}>
        <div className='win-popup-content'>
          <div className='win-popup-inner'>
            {/* <div className='win-popup-txt'>x{winOdd}</div> */}
            <div className='win-popup-txt win-popup-result-txt'>
              {winAmount} {isDemo ? DEMO_GAME_CURRENCY : currencyCode}
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className={`game-win-popup ${winAmount ? 'open' : ''}`}>
      <div className='game-win-popup-content'>
        <div className='game-win-popup-inner'>
          <div className='game-win-title'>{t(TranslationKeys.BigWin)}</div>
          <div className='game-win-number'>
            {winAmount} {isDemo ? DEMO_GAME_CURRENCY : currencyCode}
          </div>
        </div>
      </div>
    </div>
  );
});
